import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button, Dropdown, Icon, TileOptionsButton } from "aible";

import Select, { Creatable } from "react-select";

import { Modal } from "react-bootstrap";

import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import * as foldersReducer from "containers/Folders/reducer";
import { FOLDER_ROLES, ROLE_VALUES } from "containers/App/reducer";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";

const CustomOption = (props = {}) => {
  const { value, label, innerProps, data, isCustomValue } = props;

  const fullname = data?.fullname;
  const email = data?.email;

  return (
    <div className={styles.userSelectOption + " " + (isCustomValue ? styles.isValue : "")} {...innerProps}>
      <Tooltip
        trigger={["hover"]}
        overlay={
          <div>
            <div className={styles.userSelectOptionLabel}>{fullname}</div>
            <div className={styles.userSelectOptionLabel + " " + styles.small}>{email}</div>
          </div>
        }
      >
        <div style={{ maxWidth: "100%" }}>
          <div className={styles.userSelectOptionLabel}>{fullname}</div>
          <div className={styles.userSelectOptionLabel + " " + styles.small}>{email}</div>
        </div>
      </Tooltip>
    </div>
  );
};

const CustomValue = (props = {}) => {
  return <CustomOption {...props} isCustomValue />;
};

const FolderUserSelect = (props = {}) => {
  const { id, options, value, onChange, placeholder, ...retProps } = props;

  let folderId = useSelector((state) => foldersReducer.getSelectedFolder(state));
  if (id) {
    folderId = id;
  }

  let users = useSelector((state) => foldersReducer.getFolderUsers(state, folderId));
  if (options) {
    users = options;
  }
  const selectedValue = users?.find((u) => u.value === value);

  return (
    <Select
      placeholder={placeholder ?? "Select User"}
      isSearchable
      isClearable
      components={{
        Option: CustomOption,
        SingleValue: CustomValue
      }}
      options={users}
      value={selectedValue}
      onChange={onChange}
      {...retProps}
    />
  );
};

export default FolderUserSelect;
